import React, { useRef, useState } from 'react';
import Img from "../../assets/images/home-insurance/get-in-touch.webp";
import { createWebRequest } from '../../api/createWebRequest';
import Swal from "sweetalert2";
import Loader from '../loaderModal';
import { sendEmailOTP, sendOTP } from '../../api/otpVerification';
import OtpModal from '../otpModal/otpVerificationModal';
import { verifyEmailOTP, verifyOTP } from '../../api/verifyOtp';
import Captcha from '../captcha/Captcha';
import { verifyCaptcha } from '../../api/verifyCaptcha';

// Mirrors insurancex_mw's src/policies/sharedValidators.js — same rule the
// backend enforces on this field, applied live here too so a customer never
// discovers it only after clicking submit.
const REMARKS_MAX_LENGTH = 150;
const REMARKS_FORBIDDEN_CHARS_REGEX = /[$#!~`&^*?|:;]/g;

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pincode: "",
    remarks: "",
    insurance: "",
  })

  const [otpStatus, setOtpStatus] = useState("idle");
  const [otpEmailStatus, setOtpEmailStatus] = useState("idle");

  const [otpError, setOtpError] = useState("");
  const [otpModal, setOtpModal] = useState({ show: false, field: "", value: "" });
  const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
  const [isMobileVerifyEnabled, setIsMobileVerifyEnabled] = useState(false);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [otpProcessId, setOtpProcessId] = useState(null);
  const [otpLoading, setOtpLoading] = useState(false);




  const [verifyLoading, setVerifyLoading] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  // const { otpLoading, otpProcessId  } = useSelector((state) => state.dashboardSlice || {});

  const [isEmailValid, setIsEmailValid] = useState(false);

  // Submit now auto-drives mobile verification instead of just blocking:
  // if the customer hasn't clicked "Verify" on their own, clicking submit
  // sends the OTP itself and holds creating the web request until
  // handleVerifyOtp's "phone" branch succeeds (see pendingSubmit below).
  // Email verification stays fully optional throughout — no equivalent gate.
  const [pendingSubmit, setPendingSubmit] = useState(false);
  const [captchaValue, setCaptchaValue] = useState("");
  const captchaRef = useRef(null);
  // Set once verify-captcha succeeds (before OTP is ever sent); consumed by
  // doCreateWebRequest. The raw captcha itself is already spent by that
  // point either way (one-shot), so this — not captchaValue — is what
  // actually gates the final create call.
  const [proofToken, setProofToken] = useState(null);
  const [captchaVerifying, setCaptchaVerifying] = useState(false);

  const [errors, setErrors] = useState({});


  //   const handlePhoneChange = (e) => {
  //     const { name, value } = e.target;

  //     // ----- PHONE VALIDATION -----
  //     if (name === "phone") {
  //       // Allow only digits
  //       if (!/^\d*$/.test(value)) return;

  //         // ---------- VALIDATION ----------
  //   const phoneError = "";

  //   if (value.length === 1 && !/[6-9]/.test(value[0])) {
  //     phoneError = "First digit must be between 6–9";
  //   }

  //   if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
  //     phoneError = "Invalid mobile number";
  //   }
  //   setErrors((prev) => ({
  //     ...prev,
  //     phone: phoneError,
  //   }));


  //     // ----- UPDATE FORM DATA -----
  //     setFormData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   };

  //   // resetOTPState();
  //   setIsMobileVerifyEnabled(value.length === 10 && phoneError === "");

  // }



  const handlePhoneChange = (e) => {
    const value = e.target.value;
   
    // Allow only digits
    if (!/^\d*$/.test(value)) return;

    // ---------- VALIDATION ----------
    let phoneError = "";

    if (value.length === 1 && !/[6-9]/.test(value[0])) {
      phoneError = "First digit must be between 6–9";
    }

    if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
      phoneError = "Invalid mobile number";
    }

    if (otpStatus == "verified") {
      setIsMobileVerified(false);
      setOtpStatus("idle");
    }

    setErrors((prev) => ({
      ...prev,
      phone: phoneError,
    }));

    // ---------- UPDATE FORM DATA ----------
    setFormData((prev) => ({
      ...prev,
      phone: value,
    }));

    // ---------- RESET OTP STATUS ----------
    // // Any change in phone resets OTP flow
    // const resetOTPState = () => {
    //   setOtp("");
    //   setOtpError("");
    //   setOtpStatus("idle");
    //   setIsMobileVerifyEnabled(false);
    // };

    // ---------- ENABLE/DISABLE VERIFY BUTTON ----------
    setIsMobileVerifyEnabled(value.length === 10 && phoneError === "");
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "email") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const val = emailRegex.test(value)
      setIsEmailValid(emailRegex.test(value));
      console.log("value of email regex", val);
      if (otpEmailStatus == "verified") {
        setIsEmailVerified(false);
        setOtpEmailStatus("idle");
      }
      if (val) { setIsVerifyEnabled(true) };

    }


    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleSendOTP = async (field) => {
    setOtpLoading(true);
    const value = formData[field];

    const isMobile = field === "phone";
    const isEmail = field === "email";

    // Validation
    if (isMobile && !/^[0-9]{10}$/.test(value)) {
      setOtpLoading(false);
      setPendingSubmit(false);
      return Swal.fire("Invalid Mobile", "Enter a valid 10-digit mobile number", "error");
    }
    if (isEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setOtpLoading(false);
      return Swal.fire("Invalid Email", "Enter a valid email address", "error");
    }

    try {
      if (isMobile) {
        await sendOTP(value);
      } else if (isEmail) {
        await sendEmailOTP(value, formData.name);
      }
      setOtpModal({ show: true, field: field, value });
    } catch (err) {
      console.error("Error sending the OTP:", err);
      if (isMobile) setPendingSubmit(false);
    } finally {
      setOtpLoading(false);  // stop loader no matter what
    }
  }


  const handleVerifyOtp = async (otp) => {
    setVerifyLoading(true);
    const { field, value } = otpModal;
    if (!/^[0-9]{6}$/.test(otp)) {
      setVerifyLoading(false);
      return Swal.fire("Invalid OTP", "Please enter a valid 6-digit OTP", "warning");
    }

    if (field === "phone") {
      try {
        const res = await verifyOTP(value, otp);
        if (res?.apiResponseCode === "200") {
          // Mark verified first
          setIsMobileVerified(true);
          setOtpStatus("verified");
          setOtpModal({ ...otpModal, show: false });
          setErrors((prev) => ({ ...prev, mobile: "" }));
          Swal.fire("Verified", "Mobile number verified successfully", "success");

          // Update form and close modal
          setFormData((prev) => ({ ...prev, [field]: value }));
          setOtpModal({ show: false, field: "", value: "" });

          // Submit was waiting on this verification — proceed now that
          // the mobile number is confirmed.
          if (pendingSubmit) {
            await doCreateWebRequest();
          }
        } else {

          Swal.fire({
            icon: "error",
            title: "Invalid OTP",
            text: res?.apiResponseMessage || "Please try again.",
          });
          setOtpModal({ ...otpModal, show: false });
          setPendingSubmit(false);
        }
      } catch (err) {
        console.error("Error verifying the OTP:", err);
        Swal.fire("Error", `OTP verification failed for ${field}`, "error");
        setPendingSubmit(false);
      } finally {
        setVerifyLoading(false);
      }
    }
    else if (field == "email") {

      try {
        const res = await verifyEmailOTP(value, otp);
        if (res?.apiResponseCode === "200") {
          // Mark verified first
          setIsEmailVerified(true);
          setIsEmailValid(true);
          setOtpEmailStatus("verified");
          setIsVerifyEnabled(true);
          setErrors((prev) => ({ ...prev, mobile: "" }));
          Swal.fire("Verified", "Email verified successfully", "success");

          // Update form and close modal
          setFormData((prev) => ({ ...prev, [field]: value }));

          setOtpModal({ show: false, field: "", value: "" });
        } else {
          // If OTP invalid
          Swal.fire({
            icon: "error",
            title: "Invalid OTP",
            text: res?.apiResponseMessage || "Please try again.",
          });
        }
      } catch (err) {
        console.error("Error verifying the OTP:", err);
        Swal.fire("Error", `OTP verification failed for ${field}`, "error");
      } finally {
        setVerifyLoading(false);
        setOtpModal({ show: false, field: "", value: "" });
      }
    }
  }


  const [loading, setLoading] = useState(false);


  const validateForm = () => {
    const newErrors = {};

    // Full Name
    if (!formData.name.trim()) newErrors.name = "Full Name is required";

    // Email
    if (!formData.email.trim()) newErrors.email = "Email is required";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email))
      newErrors.email = "Invalid email format";

    // Phone
    if (!formData.phone.trim()) newErrors.phone = "Phone Number is required";
    else if (!/^\d{10}$/.test(formData.phone))
      newErrors.phone = "Phone must be 10 digits";

    // Insurance Type
    if (!formData.insurance) newErrors.insurance = "Please select insurance type";

    // Pin Code
    if (!formData.pincode.trim()) newErrors.pincode = "Pin Code is required";
    else if (!/^\d{6}$/.test(formData.pincode))
      newErrors.pincode = "Pin Code must be a 6-digit number";

    if (formData.remarks.length < 1) {
      newErrors.remarks = "Remarks is required";
    }

    return newErrors;
  };

  // The actual create-web-request call — split out from handleSubmit so it
  // can be triggered either immediately (mobile already verified) or from
  // handleVerifyOtp once a submit-triggered OTP verification succeeds.
  // tokenOverride is used only by the immediate-call site in handleSubmit
  // below, where setProofToken(...) hasn't been committed to state yet by
  // the time this runs synchronously after it (React state updates aren't
  // reflected in the same closure) — handleVerifyOtp's later call happens
  // in a separate event, well after that state update has landed, so it
  // can safely just read proofToken from state.
  const doCreateWebRequest = async (tokenOverride) => {
    setLoading(true);
    try {
      const payload = {
        customerName: formData.name || "",
        mobile: formData.phone,
        email: formData.email,
        productInterest: formData.insurance,
        // Appending the pincode could push a near-max-length remarks over
        // the backend's 150-char cap, so re-truncate after combining.
        remarks: (formData.pincode ? `${formData.remarks} (Pincode ${formData.pincode})` : formData.remarks).slice(0, REMARKS_MAX_LENGTH),
        pageUrl: window.location.pathname,
        proofToken: tokenOverride || proofToken,
      };

      const response = await createWebRequest(payload);

      if (response?.apiResponseCode == "200") {
        Swal.fire("Thank you!", "We've received your request and will get back to you shortly.", "success");
        setFormData({
          name: "",
          phone: "",
          email: "",
          insurance: "",
          pincode: "",
          remarks: "",
        });
        setIsEmailVerified(false);
        setIsMobileVerified(false);
        setOtpStatus("idle");
      } else {
        // Most likely the proof expired (customer took a long time on the
        // OTP step) — send them back to solve a fresh captcha rather than
        // silently failing.
        Swal.fire("Something went wrong", response?.apiResponseMessage || "Please try again.", "error");
      }
    } catch (error) {
      console.error("Error creating web request:", error);
      Swal.fire("Something went wrong", "Please try again in a moment.", "error");
    } finally {
      setLoading(false);
      setPendingSubmit(false);
      setProofToken(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validateForm();
    if (!captchaValue.trim()) validationErrors.captcha = "Please enter the code shown";
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});

    // Captcha is checked right here, before anything else happens — not
    // after the OTP round-trip. A wrong answer used to only surface after
    // the customer had already sent + entered an OTP, which was both a bad
    // UX and a wasted SMS.
    setCaptchaVerifying(true);
    let captchaResult;
    try {
      captchaResult = await verifyCaptcha(captchaRef.current?.getCaptchaId(), captchaValue);
    } catch (err) {
      console.error("Error verifying captcha:", err);
      captchaResult = null;
    } finally {
      setCaptchaVerifying(false);
    }

    // The captcha is one-shot on the backend — consumed by this attempt
    // regardless of outcome, so either way the widget needs a fresh one.
    setCaptchaValue("");
    captchaRef.current?.refresh();

    if (captchaResult?.apiResponseCode != "200") {
      setErrors({ captcha: captchaResult?.apiResponseMessage || "Incorrect captcha — please try again." });
      return;
    }
    const freshProofToken = captchaResult.apiResponseData.proofToken;
    setProofToken(freshProofToken);

    if (isMobileVerified) {
      await doCreateWebRequest(freshProofToken);
      return;
    }

    // Mobile isn't verified yet — send the OTP ourselves instead of just
    // blocking with an error. doCreateWebRequest fires from
    // handleVerifyOtp's "phone" success branch once it's confirmed.
    setPendingSubmit(true);
    await handleSendOTP("phone");
  };

  return (
    <>
      <section className="contact-two contact-two--home-1" id="getaquote" style={{ backgroundImage: "url(assets/images/shapes/contact-2-h-1-bg.png)" }}>
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-6">
              <div className="contact-two__images clearfix">
                <img src={Img} alt="Contact" />
              </div>
            </div>

            <div className="col-md-12 col-lg-6">
              {(loading || otpLoading || captchaVerifying) && (
                <div className="loader-wrapper">
                  <Loader />
                </div>
              )}
              <form  className="contact-two__form contact-form-validated" onSubmit=
                {
                  handleSubmit
                }>
                <div className="sec-title text-start">
                  <p className="sec-title__tagline">Get in Touch With Us</p>
                  <h3 className="sec-title__title">
                    Connect with us for quick support and trusted solutions.
                  </h3>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-user" />
                        Full Name <span className="form-error" >*</span>
                      </div>

                      <input type="text" value={formData.name} placeholder="" name="name" onChange={handleChange} autoComplete='off' />
                      {errors.name && <p className="form-error">{errors.name}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-phone-plus" />
                        Phone No <span className="form-error" >*</span>
                      </div>
                      <div className="input-with-action">
                        <input type="text" placeholder="" name="phone" value={formData.phone} maxLength={10} onChange={handlePhoneChange} autoComplete='off'/>
                        <button type="button" className='verify-btn' disabled={!isMobileVerifyEnabled || otpModal.show || isMobileVerified} onClick={() => { handleSendOTP("phone") }} >{isMobileVerified ? "Verified" : "Verify"}</button>
                      </div>
                      {errors.phone && <p className="form-error">{errors.phone}</p>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-envelope-open" />
                        Email Address  <span className="form-error" >*</span>
                      </div>
                      <div className="input-with-action">
                        <input type="text" placeholder="" name="email" value={formData.email} onChange={handleChange} autoComplete='off'/>
                        <button type="button" className='verify-btn'
                          disabled={!isVerifyEnabled || otpModal.show || isEmailVerified}
                          onClick={() => { handleSendOTP("email") }} >
                          {isEmailVerified ? "Verified" : "Verify"}
                        </button>
                      </div>
                      {errors.email && <p className="form-error">{errors.email}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-umbrella-beach" />
                        Type Of Insurance <span className='form-error'>*</span>
                      </div>

                      <select name="insurance" value={formData.insurance} className={`niceselect ${formData.insurance ? "selected-insurance" : ""}`} onChange={handleChange}>
                        <option value="">Select Insurance</option>
                        <option value="MOTOR">Car Insurance</option>
                        <option value="MOTOR">Bike Insurance</option>
                        <option value="HEALTH">Health Insurance</option>
                        <option value="TRAVEL">Travel Insurance</option>
                        <option value="HOME">Home Insurance</option>
                        <option value="BUSINESS">Business Insurance</option>
                      </select>
                      {errors.insurance && <p className="form-error">{errors.insurance}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-user" />
                        Pin Code <span className="form-error" >*</span>
                      </div>

                      <input type="text" placeholder="" autoComplete='off' name="pincode" value={formData.pincode} maxLength={6} onChange={(e) => {
                        const value = e.target.value;

                        // Allow only digits AND limit to 6 digits
                        if (/^\d{0,6}$/.test(value)) {
                          handleChange(e); // update state normally
                        }
                      }} />
                      {errors.pincode && <p className="form-error">{errors.pincode}</p>}

                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-umbrella-beach" />
                        Remarks    <span className='form-error'>*</span>
                      </div>

                      <input type="text" placeholder="" autoComplete='off' name="remarks" value={formData.remarks} maxLength={REMARKS_MAX_LENGTH} onChange={(e) => {
                        const cleaned = e.target.value.replace(REMARKS_FORBIDDEN_CHARS_REGEX, "");
                        setFormData((prev) => ({ ...prev, remarks: cleaned }));
                      }} />
                      {errors.remarks && <p className="form-error">{errors.remarks}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <Captcha ref={captchaRef} value={captchaValue} onChange={setCaptchaValue} error={errors.captcha} />
                  </div>

                  <div className="col-md-12">
                    <div className="contact-two__input">
                      <button type="submit"
                        className="thm-btn thm-btn--three contact-two__btn"  >
                        <span>
                          Get a Quote
                          <i className="far fa-arrow-right" />
                        </span>
                      </button>
                    </div>
                  </div>
                  {loading || otpLoading && (
                    <div className="loader-wrapper">
                      <Loader />
                    </div>
                  )}
                  {errors.submit && <p className="form-error">{errors.submit}</p>}
                </div>
                {otpModal.show && (
                  <>   {(otpLoading || verifyLoading) && <Loader />}
                    <OtpModal
                      field={otpModal.field}
                      value={otpModal.value}
                      onClose={() => {
                        setOtpModal({ show: false, field: "", value: "" });
                        setPendingSubmit(false);
                      }}
                      onVerified={handleVerifyOtp}
                      verifyLoading={verifyLoading}
                    />
                  </>
                )}
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Contact;
